<template>
    <div>
        <b-card :header="uLang('app.edit')" header-tag="h4" class="bg-default-card">
            <trajectory-form v-if="project" :id="id" :project="project" :override-endpoint="overrideEndpoint"/>
        </b-card>
    </div>
</template>

<script>
    import TrajectoryForm from '~/components/forms/admin/projects/trajectory/form'

    export default {
        name: 'edit',
        props: {
            id: {
                required: true,
            },
            projectId: {
                required: true,
            },
        },

        data() {
            return {
                project: null,
            }
        },

        created() {
            this.retrieveProject();
        },

        methods: {
            async retrieveProject() {
                let {data} = await window.axios.get(route('trajectory-projects.show', {trajectory_project: this.projectId}));
                this.project = data;
            },
        },

        components: {
            'trajectory-form': TrajectoryForm,
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.store', { trajectory_project: this.projectId })
            }
        },
    }
</script>

<style lang="css" scoped>
</style>
